<template>
    <div :id="containerId">
        <oc-alert
            v-for="(flash, flashIndex) in messages[container]"
            :key="flashIndex"
            v-bind="flash"
            @close="$hideFlashMessage(flashIndex, container)"
        />
    </div>
</template>

<script>
let VueScrollTo = require('vue-scrollto')

let scrollTimeout

export default {
    name: 'oc-flash-messages',
    props: {
        container: {
            type: String,
            default: () => 'default'
        },
        scrollOptions: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            scrollStarted: false,
            messages: this.$flashMessages
        }
    },
    computed: {
        containerId() {
            return `flash-messages-${this.container}`
        }
    },
    watch: {
        '$route.fullPath': {
            immediate: true, // on created
            handler() {
                this.$manageFlashMessagesHops(this.container)
            }
        },
        messages: {
            deep: true,
            handler() {
                // scroll to errors

                if( scrollTimeout ) {
                    clearTimeout(scrollTimeout)
                }

                scrollTimeout = setTimeout(() => {
                    VueScrollTo.scrollTo(`#${this.containerId}`, this.scrollOptions.speed || 400, Object.assign({}, {
                        offset: -60,
                        force: false,
                        onDone: () => {
                            this.scrollStarted = false
                        }
                    }, this.scrollOptions))
                }, 100);
            }
        }
    }
}
</script>
